import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState
} from 'react';
import cloneDeep from 'lodash/cloneDeep';
import FormBuilderFlagRulesView from '../view/FormBuilderFlagRulesView';
import { FormBuilderContext } from './FormBuilderEngine';
import useFetchWithCallbacks from '../../hooks/useFetchWithCallbacks';
import { trimConditions } from '../conditions-query-builder/engine/ConditionsQueryBuilderEngine';
import { defaultComparisonMap } from '../../internal-components/conditional-logic/defaultComparisonMap';
import { getAllFields } from '../../internal-components/form-builder/getAllFields';
import { compareTypeMap } from '../../internal-components/conditional-logic/compareTypeMap';

const FormBuilderFlagRulesEngine = ({
  query: initialQuery,
  fieldId,
  rules,
  setRules
}) => {
  const [query, setQuery] = useState(initialQuery);
  const { form } = useContext(FormBuilderContext);

  const skipUpdate = useRef(true);
  const fetchAPI = useFetchWithCallbacks();

  const flagQueryUpdate = updatedRule => {
    let newRulesArray = cloneDeep(rules);
    const existingRuleForField = newRulesArray.find(
      o => o.fieldId === fieldId && o.action && o.action.actionType === 'flag'
    );
    newRulesArray = newRulesArray.filter(
      o => o.fieldId !== fieldId || !o.action || o.action.actionType !== 'flag'
    );
    const newRuleObject = {
      action: {
        actionType: 'flag',
        parameters: [{ key: 'flag', value: fieldId }]
      },
      condition: JSON.stringify([updatedRule]),
      fieldId: fieldId,
      formId: form.id,
      id: existingRuleForField ? existingRuleForField.id : undefined
    };
    try {
      if (
        existingRuleForField &&
        JSON.stringify(newRuleObject.condition) ===
          JSON.stringify(existingRuleForField.condition)
      ) {
        return;
      }
    } catch (e) {}
    if (!updatedRule || !updatedRule.length) {
      if (existingRuleForField) {
        fetchAPI(`/forms/v1/rules/${existingRuleForField.id}`, {
          method: 'DELETE'
        }).then(res => {
          setRules(newRulesArray);
        });
      }
      return;
    }
    fetchAPI(
      '/forms/v1/rules' +
        (existingRuleForField ? `/${existingRuleForField.id}` : ''),
      {
        body: newRuleObject,
        method: existingRuleForField ? 'PUT' : 'POST',
        handleResponse: r =>
          r
            .text()
            .then(text => (text ? JSON.parse(text) : {}))
            .then(json => {
              if (r.ok) {
                return r;
              } else {
                return Promise.reject({
                  response: r,
                  json
                });
              }
            })
      }
    ).then(r => {
      let idFromLocation;
      if (!existingRuleForField) {
        newRuleObject.id = r.headers.map.location;
      }
      newRulesArray.push(newRuleObject);
      setRules(newRulesArray);
    });
  };

  useEffect(() => {
    // if (skipUpdate.current) {
    //   skipUpdate.current = false;
    //   return;
    // }
    flagQueryUpdate(trimConditions(query));
  }, [query]);

  const onCreateRule = useCallback(() => {
    const allFields = getAllFields(form);

    const { uiType } = allFields.find(f => f.internalId === fieldId);
    const compareType = compareTypeMap[uiType];

    const query = defaultComparisonMap[compareType];
    query.field = '${' + fieldId + '}';
    query.internOp = 'and';
    if (uiType === 'multiple_choice' || uiType === 'yes_no') {
      query.internOp = 'or';
    }
    setQuery([query]);
  }, [fieldId, form]);

  const onQueryUpdated = val => {
    // if (JSON.stringify(val[0]) === '{}') {
    //   skipUpdate.current = true;
    // }
    setQuery(val);
  };

  const viewProps = {
    query,
    form,
    fieldId,
    onCreateRule,
    onQueryUpdated
  };

  return <FormBuilderFlagRulesView {...viewProps} />;
};

export default FormBuilderFlagRulesEngine;
